import { useOrgData } from "../../../../contexts/OrgDataContext";
import { useMemo, useState } from "react";
import Badge from "../../../../components/badges/Badge";
import { getIcon, getText, LOGS_TYPES } from "../../../../services/log/log-service";
import moment from "moment/moment";
import { InformationCircleIcon, TagIcon } from "@heroicons/react/20/solid";

export const DefaultPatternLog = ({ log }) => {
  const { eventTypes } = useOrgData();

  const [arePatternLogsVisible, setArePatternLogsVisible] = useState(false);

  const patternLogs = useMemo(() => log?.pattern_logs, [log]);

  const togglePatternLogs = () => {
    setArePatternLogsVisible(!arePatternLogsVisible);
  };

  return useMemo(
    () => (
      <div className="ml-8 border-l-1 border-perception-gray-600 relative flex pb-2 pr-4 cursor-pointer" onClick={togglePatternLogs}>

        {/* Circle */}
        <div className="absolute size-3 top-0 -left-1.5 rounded-full bg-perception-gray-500">
          {/* TODO Manage circle color */}
          <div className="size-2 bg-perception-blue absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full"/>
        </div>

        {/* Datetime */}
        <div className="text-sm -mt-1 w-32 text-center">
          {moment(log.time).format('HH:mm:ss')}
        </div>

        {/* Pattern content */}
        <div className="flex-1 bg-perception-black-800 px-4 py-4 rounded-md relative overflow-hidden">
          <div className="bg-perception-blue w-1 absolute top-1.5 bottom-1.5 left-1.5 rounded-md"/>

          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4 ml-3">
              <TagIcon className="size-4 text-perception-blue"/>
              <div className="">
                {log.pattern_name}
              </div>
            </div>
            {/* Complete tag */}
            {
              log.percentage === 100 ?
                <Badge text="Conforme" type="green" /> :
                <Badge text={`Incomplet (${Math.round(log.percentage)}%)`} type='yellow' />
            }
          </div>

          {arePatternLogsVisible &&
            <div className="mt-4">
              {
                log?.pattern_logs?.map((patternLog, patternLogIndex) => (
                  <div key={patternLogIndex} className="ml-12 border-l-1 border-perception-gray-600 last:border-transparent relative flex pr-4 pb-2 last:pb-0">

                    {/* Circle */}
                    <div className="absolute size-3 top-0 -left-1.5 rounded-full bg-perception-gray-500">
                      {/* TODO Manage circle color */}
                      <div className="size-2 bg-perception-black-800 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full"/>
                    </div>

                    {/* Datetime */}
                    <div className="text-xs -mt-0.5 w-24 text-center">
                      {moment(patternLog.time).format('HH:mm:ss')}
                    </div>

                    {/* Log content */}
                    {/* TODO Manage alerts -> getType(log) === 'ALERT' */}
                    <div className="flex-1 bg-perception-black-800 rounded-md flex justify-between items-center text-sm -mt-1 ml-4 text-perception-gray-600">
                      <div className="flex items-center gap-4">
                        {/* TODO Manage icon */}
                        <InformationCircleIcon className="size-4"/>
                        <div className="text-sm">
                          {getText(patternLog, {}, true, eventTypes)}
                        </div>
                      </div>
                      <Badge text="Conforme" type="green" />
                    </div>
                  </div>
                ))
              }
            </div>
          }

        </div>
      </div>
    ),
    [arePatternLogsVisible, log, patternLogs],
  );
};

const LogLayout = ({ children }) => <div className='flex'>{children}</div>;

const LogTime = ({ log }) => <p className='text-xs'>{moment(log.time).format('HH:mm:ss')}</p>;

const LogIcon = ({ log, size }) => {
  const sizeClass = size === 'small' ? 'w-6 h-6' : 'w-10 h-10';
  const borderColor = log.type === LOGS_TYPES.PATTERN ? 'border-perception-blue' : 'border-perception-gray-500';

  return (
    <div className={`${sizeClass} rounded-full flex justify-center items-center border ${borderColor}`}>
      {getIcon(log, size)}
    </div>
  );
};